import { useEffect, useState } from "react";
import { NovaOrb } from "../components/NovaOrb";
import { BottomNav } from "../components/BottomNav";
import { api } from "../lib/api";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";

const STATS = [
  "79% felt lost on day one",
  "63% derailed by life, not laziness",
  "~50% gone by month six",
];

export default function Nova() {
  const [line, setLine] = useState("");
  const [scienceOpen, setScienceOpen] = useState(false);

  useEffect(() => {
    api.get("/nova/today").then(({ data }) => setLine(data.reflection_line)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-kaizen-bg text-kaizen-text pb-28" data-testid="nova-page">
      <div className="absolute inset-0 -z-10 h-[360px] bg-[radial-gradient(circle_at_50%_0%,rgba(139,93,199,0.18),transparent_65%)]" />

      <div className="max-w-md mx-auto px-5 pt-10">
        <div className="flex flex-col items-center text-center">
          <NovaOrb size={120} />
          <p className="font-display text-xl mt-5" data-testid="nova-reflection-line">
            {line}
          </p>
        </div>

        <div className="glass-card rounded-3xl p-6 mt-8" data-testid="nova-why-card">
          <p className="text-xs uppercase tracking-widest text-kaizen-dim mb-3">Why we built this</p>
          <p className="font-display italic text-lg text-kaizen-violetSoft leading-relaxed">
            "We interviewed people who quit the gym. None of them were lazy."
          </p>
          <ul className="mt-4 space-y-2">
            {STATS.map((s) => (
              <li key={s} className="text-sm text-kaizen-text/90 flex items-center gap-2" data-testid="nova-why-stat">
                <span className="w-1 h-1 rounded-full bg-kaizen-violetSoft shrink-0" />
                {s}
              </li>
            ))}
          </ul>
          <p className="text-sm text-kaizen-dim mt-4 leading-relaxed">
            So we built the coach for your worst week. Small beats zero.
          </p>
        </div>

        <button
          onClick={() => setScienceOpen(true)}
          data-testid="the-science-trigger"
          className="w-full mt-4 text-center text-xs text-kaizen-dim2 underline hover:text-kaizen-violetSoft transition-colors duration-300"
        >
          The science
        </button>
      </div>

      <Sheet open={scienceOpen} onOpenChange={setScienceOpen}>
        <SheetContent side="bottom" className="bg-kaizen-bg border-white/10 text-kaizen-text" data-testid="the-science-sheet">
          <SheetHeader>
            <SheetTitle className="font-display text-kaizen-text">The science</SheetTitle>
          </SheetHeader>
          <p className="text-sm text-kaizen-dim leading-relaxed mt-3">
            Habit-formation research puts real automaticity closer to 66 days of repetition, not the popular "21 days"
            myth. Tiny-habits research shows that protecting the smallest possible version of a habit — the floor —
            is what keeps someone's identity as "a person who shows up" intact through a hard week, which is the
            actual mechanism that rebuilds consistency after a lapse.
          </p>
        </SheetContent>
      </Sheet>

      <BottomNav />
    </div>
  );
}
